import { useEffect, useRef } from "react";
import Lenis from "lenis";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import CookieBanner from "@/components/CookieBanner";
import { useConfig } from "@/context/ConfigContext";

export default function PublicLayout({ children, variant = "home" }) {
  const config = useConfig();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.0, smoothWheel: true });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    window.scrollTo(0, 0);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-paper text-ink min-h-screen">
      <Header variant={variant} />
      <main>{children}</main>
      <Footer config={config} />
      <WhatsAppButton config={config} variant={variant} />
      <CookieBanner />
    </div>
  );
}
